import React from "react";
import {
    Create,
    DateInput,
    Edit,
    ImageField,
    ImageInput,
    LongTextInput,
    SimpleForm,
    TextInput
} from 'react-admin';

const RecordTitle = ({record}) => (
    <span>Record {record ? `"${record.slug || record.name}"` : ''}</span>
);

const PeopleForm = (props) => (
    <SimpleForm {...props} >
        <TextInput readOnly label="Id" source="id" />
        <TextInput readOnly label="slug" source="slug" />
        <TextInput source="fullname"  />
        <TextInput multiline source="bio" label="Synopsis/Bio" />

        <TextInput source="imdb_id" />
        <DateInput label="BirthDay" source="birthday" />

        <ImageInput source="photos" label="Related pictures" accept="image/png" placeholder={<p>Drop your file here</p>}>
            <ImageField source="url" title="alt" />
        </ImageInput>

        <TextInput readOnly label="Created date" source="createdAt" />
        <TextInput readOnly label="Updated date" source="updatedAt" />
    </SimpleForm>
);

export const PeopleEdit = (props) => (
    <Edit title={<RecordTitle />} {...props}>
        <PeopleForm />
    </Edit>

);


export const PeopleCreate = (props) => (
    <Create title={<RecordTitle />} {...props}>
        <PeopleForm />
    </Create>
);
